import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's125g-s125m01',
    templateUrl: './s125g-s125m01.component.html'
})
export class S125gS125m01Component extends Overlay {
    scrndat: any = {};
    scrntim: any = {};
    series: any = {};
    revnbr: any = {};
    pnrnbr: any = {};
    pnrcrdt: any = {};
    actvtyp: any = {};
    dmyind: any = {};
    txntyp: any = {};
    pnragnt: any = {};
    pnrloc: any = {};
    pnrout: any = {};
    spolmsg: any = {};
    outlet: any = {};
    altdel: any = {};
    psgrnm: any = {};
    priced: any = {};
    alocmth: any = {};
    issuedt: any = {};
    agent: any = {};
    aaa: any = {};
    prntrid: any = {};
    gds: any = {};
    pltcarr: any = {};
    monhdgs: any = {};
    hotmsg: any = {};
    montotl: any = {};
    mondetl: any = {};
    stdttl: any = {};
    fopln1: any = {};
    fopln2: any = {};
    fopln3: any = {};
    fopln4: any = {};
    fopln5: any = {};
    fopln6: any = {};
    fopln7: any = {};
    fopln8: any = {};
    fopln9: any = {};
    fopln10: any = {};
    fopln11: any = {};
    fopln12: any = {};
    msgln: any = {};
    selmen: any = {'value': '2-SEL'};
    prev: any = {'value': '7-PREV'};
    next: any = {'value': '8-NEXT'};
    prnt: any = {'value': '12-PRINT'};
    currc1: any = {'value': 'SH4-CUST INQ'};
    prevc1: any = {'value': 'SH3-PREV CUST INQ'};
    paymt: any = {'value': 'SH5-PAYMT'};
    last: any = {'value': 'SH6-LAST'};
    first: any = {'value': 'SH7-FIRST'};

    public FIELDS: string[] = ['scrndat', 'scrntim', 'series', 'revnbr', 'pnrnbr', 'pnrcrdt', 'actvtyp', 'dmyind', 'txntyp', 'pnragnt', 'pnrloc', 'pnrout', 'spolmsg', 'outlet', 'altdel', 'psgrnm', 'priced', 'alocmth', 'issuedt', 'agent', 'aaa', 'prntrid', 'gds', 'pltcarr', 'monhdgs', 'hotmsg', 'montotl', 'mondetl', 'stdttl', 'fopln1', 'fopln2', 'fopln3', 'fopln4', 'fopln5', 'fopln6', 'fopln7', 'fopln8', 'fopln9', 'fopln10', 'fopln11', 'fopln12', 'msgln', 'selmen', 'prev', 'next', 'prnt', 'currc1', 'prevc1', 'paymt', 'last', 'first'];
    public LINES: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

    ngAfterViewInit(): void {
    }
}
